export default "__VITE_ASSET__4290f5c5__"